import React from 'react'
import { M_Table } from 'src/components/M_Components'

export const DistanceEstimatedTime = ({ roles }) => {
    return (
        <M_Table entityName={'DistanceEstimatedTime'} filtersOnTable rolePermissions={roles}/>
    )
}